// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","container":"styles_container__J5q2g","pane":"styles_pane__AKDSe"};